import { Button, Col, message, Modal, Row, Space } from 'antd'
import { AiKoutuIcon } from '../Icons/AiKoutuIcon'
import styles from './styles.module.scss'

import { useEffect, useMemo, useState } from 'react'
import { FileDTO, SHIBEI_KOUTU } from '@/api/MaterialApi'
import AsyncButton from '../AsyncButton'

export type AiKoutuButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSaveKoutu?: (
    oldUrl: string,
    newUrl: string,
    options: {
      oldInfo: any
      newInfo: any
    },
  ) => Promise<void>
}

export function getOriginImageUrl(imageInfo: any) {
  if (!imageInfo) {
    return ''
  }
  if (imageInfo?.url?.startsWith('/')) {
    return imageInfo?.baseUrl + imageInfo?.url
  }
  return imageInfo?.url
}
export function AiKoutuButton(props: AiKoutuButtonProps) {
  const [isModelOpen, setIsModelOpen] = useState(false)
  //   const [kouTuUrl, setKouTuUrl] = useState('')
  const [koutuRes, setKoutuRes] = useState<FileDTO[]>([])
  const [loading, setLoading] = useState(false) // 新增loading状态
  const { originImgUrl, imageInfo, onSaveKoutu, productCode } = props

  const openModal = () => {
    setIsModelOpen(true)
  }

  const closeModal = () => {
    setIsModelOpen(false)
    setKoutuRes([]) // 关闭弹窗时清空抠图URL
  }

  async function getKoutuUrl() {
    if (!originImgUrl) return
    setLoading(true)
    try {
      //  参考文档: https://docs.zcbot.cn/pages/seabase/open/koutu/#%E6%8E%A5%E5%8F%A3%E8%AF%B7%E6%B1%82
      //   const apiUrl = `https://open-api.zcbot.cn/koutu-api/koutu/url?url=${encodeURIComponent(
      //     originImgUrl,
      //   )}`
      const res = await SHIBEI_KOUTU({
        url: originImgUrl,
        productCode: productCode,
      })

      if (res.code === 0) {
        setKoutuRes(res.data)
      } else {
        // 可以添加错误处理，例如使用 antd 的 message 组件提示用户
        console.error('AI抠图失败:', res.msg)
        message.error(res.msg || 'AI抠图失败')
      }
    } catch (error) {
      console.error('请求AI抠图接口失败:', error)
      // message.error('请求AI抠图接口失败');
    } finally {
      setLoading(false)
    }
  }

  async function handleSaveKoutu() {
    const newInfo = koutuRes?.[0]
    const newUrl = getOriginImageUrl(newInfo)

    await onSaveKoutu?.(originImgUrl ?? '', newUrl, {
      oldInfo: imageInfo,
      newInfo,
    })
    closeModal()
  }
  useEffect(() => {
    if (isModelOpen && originImgUrl) {
      getKoutuUrl()
    }
  }, [isModelOpen, originImgUrl])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <AiKoutuIcon />
        <span>AI抠图</span>
      </Space>
      <Modal
        title={'AI抠图'}
        onCancel={closeModal}
        footer={
          <Row justify={'center'}>
            <Space>
              <Button onClick={closeModal}>取消</Button>
              <AsyncButton type="primary" onClick={handleSaveKoutu}>
                保存抠图
              </AsyncButton>
            </Space>
          </Row>
        }
        zIndex={2000}
        open={isModelOpen}
        width={800} // 适当调整弹窗宽度
      >
        <Row gutter={16}>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>原图</h3>
            {originImgUrl ? (
              <img
                src={originImgUrl}
                alt="原图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            ) : (
              <p>暂无原图</p>
            )}
          </Col>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>AI抠图结果</h3>
            {loading && <p>抠图中，请稍候...</p>}
            {!loading && koutuRes && (
              <img
                src={getOriginImageUrl(koutuRes?.[0])}
                alt="AI抠图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            )}
            {!loading && !koutuRes && originImgUrl && <p>抠图失败或未开始</p>}
            {!originImgUrl && <p>请先提供原图</p>}
          </Col>
        </Row>
      </Modal>
    </>
  )
}
import { Button, Col, message, Modal, Row, Space } from 'antd'
import { AiKoutuIcon } from '../Icons/AiKoutuIcon'
import styles from './styles.module.scss'

import { useEffect, useMemo, useState } from 'react'
import { FileDTO, SHIBEI_KOUTU } from '@/api/MaterialApi'
import AsyncButton from '../AsyncButton'

export type AiKoutuButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSaveKoutu?: (
    oldUrl: string,
    newUrl: string,
    options: {
      oldInfo: any
      newInfo: any
    },
  ) => Promise<void>
}

export function getOriginImageUrl(imageInfo: any) {
  if (!imageInfo) {
    return ''
  }
  if (imageInfo?.url?.startsWith('/')) {
    return imageInfo?.baseUrl + imageInfo?.url
  }
  return imageInfo?.url
}
export function AiKoutuButton(props: AiKoutuButtonProps) {
  const [isModelOpen, setIsModelOpen] = useState(false)
  //   const [kouTuUrl, setKouTuUrl] = useState('')
  const [koutuRes, setKoutuRes] = useState<FileDTO[]>([])
  const [loading, setLoading] = useState(false) // 新增loading状态
  const { originImgUrl, imageInfo, onSaveKoutu, productCode } = props

  const openModal = () => {
    setIsModelOpen(true)
  }

  const closeModal = () => {
    setIsModelOpen(false)
    setKoutuRes([]) // 关闭弹窗时清空抠图URL
  }

  async function getKoutuUrl() {
    if (!originImgUrl) return
    setLoading(true)
    try {
      //  参考文档: https://docs.zcbot.cn/pages/seabase/open/koutu/#%E6%8E%A5%E5%8F%A3%E8%AF%B7%E6%B1%82
      //   const apiUrl = `https://open-api.zcbot.cn/koutu-api/koutu/url?url=${encodeURIComponent(
      //     originImgUrl,
      //   )}`
      const res = await SHIBEI_KOUTU({
        url: originImgUrl,
        productCode: productCode,
      })

      if (res.code === 0) {
        setKoutuRes(res.data)
      } else {
        // 可以添加错误处理，例如使用 antd 的 message 组件提示用户
        console.error('AI抠图失败:', res.msg)
        message.error(res.msg || 'AI抠图失败')
      }
    } catch (error) {
      console.error('请求AI抠图接口失败:', error)
      // message.error('请求AI抠图接口失败');
    } finally {
      setLoading(false)
    }
  }

  async function handleSaveKoutu() {
    const newInfo = koutuRes?.[0]
    const newUrl = getOriginImageUrl(newInfo)

    await onSaveKoutu?.(originImgUrl ?? '', newUrl, {
      oldInfo: imageInfo,
      newInfo,
    })
    closeModal()
  }
  useEffect(() => {
    if (isModelOpen && originImgUrl) {
      getKoutuUrl()
    }
  }, [isModelOpen, originImgUrl])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <AiKoutuIcon />
        <span>AI抠图</span>
      </Space>
      <Modal
        title={'AI抠图'}
        onCancel={closeModal}
        footer={
          <Row justify={'center'}>
            <Space>
              <Button onClick={closeModal}>取消</Button>
              <AsyncButton type="primary" onClick={handleSaveKoutu}>
                保存抠图
              </AsyncButton>
            </Space>
          </Row>
        }
        zIndex={2000}
        open={isModelOpen}
        width={800} // 适当调整弹窗宽度
      >
        <Row gutter={16}>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>原图</h3>
            {originImgUrl ? (
              <img
                src={originImgUrl}
                alt="原图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            ) : (
              <p>暂无原图</p>
            )}
          </Col>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>AI抠图结果</h3>
            {loading && <p>抠图中，请稍候...</p>}
            {!loading && koutuRes && (
              <img
                src={getOriginImageUrl(koutuRes?.[0])}
                alt="AI抠图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            )}
            {!loading && !koutuRes && originImgUrl && <p>抠图失败或未开始</p>}
            {!originImgUrl && <p>请先提供原图</p>}
          </Col>
        </Row>
      </Modal>
    </>
  )
}
